import { useEffect } from "react"
import { IPETest } from "../../data/interfaces"
import { useDataStore } from "src/modules/pe-basic-module/data/store"
import { actions } from "../../data/actions"
import { GET_ALL_TESTS_ACTION } from "../../data/actionTypes"
import Feed from "src/modules/pe-basic-module/views/core/Feed"
import { Link } from "react-router-dom"
import { Button } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"

/* Protopia Ecosystem component */
export interface ITestResultTestsListProps {
   link: string
}
const TestResultTestsList = (props: ITestResultTestsListProps): JSX.Element => {
    const tests: IPETest[] = useDataStore((state: any) => state.PETest || [] )
    useEffect(() => {
        actions(GET_ALL_TESTS_ACTION, {})
    }, [])

    

    const setFooter = (item: any ) : JSX.Element => {
        return <div className="mt-2 w-100 d-flex justify-content-between align-items-center">
            <div className="mx-2 small letter-spacing-2 pe-surface3">
                <div className="opacity_5 small">ID: {item.id}</div>
            </div>
            <Link to={ props.link + "/results?meta_key=test_id&meta_value="+ item.id }>
                <Button variant="minimal">
                    {__("Test results")}
                </Button>
            </Link>
        </div>
    }

    return <div className='pe-test-result-tests-list-container'>
        <Feed
            items={tests}
            data_type={""}
            setFooter={setFooter}
        />
    </div>
}
export default TestResultTestsList